module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/amps-9aa665072b6f97c099493874b87c039c.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/amps.png
// module id = YfL3
// module chunks = 12 16 18